
export const SellerNavigationQuery = new TypedDocumentString(`
    query SellerNavigationQuery($handle: String!) {
  publicSeller(handle: $handle) {
    _id
    doc {
      _id
      navigation {
        ...SellerNavigation
        __typename
      }
      __typename
    }
    __typename
  }
}
    fragment SellerLink on SellerLink {
  alt
  type
  slug
  sellerId
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment SellerTextLink on SellerTextLink {
  text {
    value
    __typename
  }
  link {
    ...SellerLink
    __typename
  }
  __typename
}
fragment SellerNavigation on SellerNavigation {
  id
  pages {
    title {
      ...SellerTextLink
      __typename
    }
    cols {
      title {
        ...SellerTextLink
        __typename
      }
      imageRatio
      image {
        ...Image
        __typename
      }
      rows {
        title {
          ...SellerTextLink
          __typename
        }
        imageRatio
        image {
          ...Image
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}`, {"hash":"6cfeb1fb902d901beb822fbaaf130355d65e7a5d581027020e27dddf1db6ba72"});